import React from 'react'
import { Outlet } from 'react-router-dom'
import PatchNotes from '../PatchNotes'

const DashboardHome = () => {
  return (
    <div>
        <PatchNotes dashboard={true} />
        <Outlet />
    </div>
  )
}

export default DashboardHome